import calendarEventsConstants from '@constants/calendarEvents.constants'

export default [
  {
    value: calendarEventsConstants.ALIGNER_CHECK_IN,
    label: 'Aligner check-in',
  },
  {
    value: calendarEventsConstants.RESUME_TREATMENT_REMINDER,
    label: 'Resume treatment reminder',
  },
  {
    value: calendarEventsConstants.ALIGNER_CHANGED,
    label: 'Aligner change',
  },
  {
    value: calendarEventsConstants.APPOINTMENT_REMINDER,
    label: 'Appointment reminder',
  },
  {
    value: calendarEventsConstants.PRODUCTION_REMINDER,
    label: 'Production reminder',
  },
  {
    value: calendarEventsConstants.GENERAL_REMINDER,
    label: 'General reminder',
  },
  {
    value: calendarEventsConstants.PAYMENT_REMINDER,
    label: 'Payment reminder',
  },
  {
    value: calendarEventsConstants.TRIAL_PLAN_EXPIRING,
    label: 'Subscription',
  },
  {
    value: calendarEventsConstants.BASIC_PLAN_EXPIRING,
    label: 'Subscription',
  },
  {
    value: calendarEventsConstants.APPOINTMENT,
    label: 'Appointment',
  },
  {
    value: calendarEventsConstants.TREATMENT_START_REMINDER,
    label: 'Treatment start reminder',
  },

  {
    value: calendarEventsConstants.UNPROCESSED_ALIGNER_REMINDER,
    label: 'Reminder: Start manufacturing the next batch for',
  },
]
